import { render, staticRenderFns } from "./orderPwd.vue?vue&type=template&id=dd320538&"
import script from "./orderPwd.vue?vue&type=script&lang=js&"
export * from "./orderPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports